import React from 'react'
import clsx from 'clsx'
import Pluralize from 'pluralize'
import SongwriterCatalogBuilderToggle from '@Components/SongwriterCatalogBuilderToggle'
import { SearchResultPartyDetails } from '@Entities/party-details'
import { ICONS } from '@Const/common'
import { observer } from 'mobx-react'
import numberOrZero from '@App/helpers/number-or-zero'

interface SongwriterCatalogBuilderRowProps {
    writer: SearchResultPartyDetails
    onTitleClick: (partyDetails: SearchResultPartyDetails) => void
    onWriterToggle: (isLinked: boolean, writerIpId: number) => void
    isChecked: boolean
    requestAnUpdate(selectedWriter: SearchResultPartyDetails): void
}

const SongwriterMyWritersRow = (props: SongwriterCatalogBuilderRowProps) => {
    const { writer, onTitleClick, onWriterToggle, isChecked, requestAnUpdate } = props

    return (
        <div className="songwriter-my-writer-table-row" key={writer.ipId}>
            <SongwriterCatalogBuilderToggle
                onClick={(isLinked: boolean) => {
                    onWriterToggle(isLinked, Number(writer.ipId))
                }}
                internalLabel={isChecked ? 'Yes' : 'No'}
                checked={isChecked}
            />
            <div className="writer-data">
                <div className="writer-name-titles">
                    <span className="writer-name">{writer.name}:</span>
                </div>
                <div className="writer-ipi">
                    <span>IPI:</span> {writer.ipiNumber}
                </div>
            </div>
            <div
                className={clsx('writer-works', !!writer.worksCount && 'clickable')}
                onClick={() => !!writer.worksCount && onTitleClick(writer)}
            >
                <div className="writer-titles">
                    <span>{writer.worksCount}</span>
                    <span>{Pluralize('Song', numberOrZero(writer.worksCount))}</span>
                </div>
                <img className="right-chevron" src={ICONS.chevron_right} alt="right chevron icon" />
            </div>
            <button
                type="button"
                className="icon-with-caption request-update-button"
                onClick={() => requestAnUpdate(writer)}
                aria-label="Request Update"
            >
                <img className="right-chevron" src={ICONS.flag} alt="flag icon" />
                <p>Request Update</p>
            </button>
        </div>
    )
}

export default observer(SongwriterMyWritersRow)
